<ng-container *ngIf="shouldDisplayBreadcrumb">
  <ng-container [ngSwitch]="componentRenderState()">
    <ng-container *ngSwitchCase="'content'">
      <a
        [routerLink]="redirectURL"
        [queryParams]="queryParams"
        [queryParamsHandling]="queryParamsHandling"
        class="breadcrumb-link focus-link"
        data-analytics-nav="breadcrumb">
        <span class="breadcrumb-content">
          <rd-shared-icon
            class="back-icon h-6 w-5"
            [iconSymbol]="'icon-back'"
            [iconTheme]="'default'"></rd-shared-icon>
          <span class="breadcrumb-text">{{ breadcrumbText }}</span>
        </span>
      </a>
    </ng-container>

    <ng-container *ngSwitchCase="'loading'">
      <div class="breadcrumb-link breadcrumb-link-loading"></div>
    </ng-container>
  </ng-container>
</ng-container>
